import { render, staticRenderFns } from "./UiCounter.vue?vue&type=template&id=1a14b1ec&lang=pug&"
import script from "./UiCounter.vue?vue&type=script&lang=js&"
export * from "./UiCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports